import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";


// Action Types
export const CHANGE_TYPE_SUCCESS = "CHANGE_TYPE_SUCCESS";
export const CHANGE_TYPE_ERROR = "CHANGE_TYPE_ERROR";

export const changeTypeOfTodo = createAsyncThunk(
    "api/Task/changeType",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/changeType/${json.id}`,
                    {
                        type: json.type
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                // Check for response status and store in IndexedDB
                if (response.status === 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error occured changing type");
                }

                // Retrieve data from IndexedDB
                //const taskListData = await idb.getTasks();

                // Dispatch success action with data from IndexedDB
                dispatch({
                    type: CHANGE_TYPE_SUCCESS,
                    payload: response.data,
                });
            } else {
                // Offline handling: get data from IndexedDB
                const taskListData = await idb.getTasks();

                if (taskListData) {
                    // Dispatch success action with data from IndexedDB
                    dispatch({
                        type: CHANGE_TYPE_SUCCESS,
                        payload: taskListData
                    });
                } else {
                    console.log("No tasks found in IndexedDB");
                }
            }

        } catch (error) {
            // Dispatch error action if any exception occurs
            dispatch({ type: CHANGE_TYPE_ERROR, payload: error.message || error });
            await signOut();
        }
    }
);

//.then(response => {
//    dispatch({
//        type: CHANGE_TYPE_SUCCESS,
//        payload: response.data,
//    });
//})
//.catch(error => {
//    dispatch({ type: CHANGE_TYPE_ERROR, payload: error });
//});